import { render, staticRenderFns } from "./DataSource.vue?vue&type=template&id=bbb7cbac&scoped=true&"
import script from "./DataSource.vue?vue&type=script&lang=js&"
export * from "./DataSource.vue?vue&type=script&lang=js&"
import style0 from "./DataSource.vue?vue&type=style&index=0&id=bbb7cbac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb7cbac",
  null
  
)

export default component.exports